import howToInvestBondsImg from 'assets/images/howToInvestBonds.png';

import { FLIP_BOOK, GIFT_BOOK, FLIP_BOOKS } from '../const';

import { getFlipBookPurchases } from './utils';

const howToInvestBonds = {
  book: {
    id: 'geldanlegen-obligationen',
    format: FLIP_BOOKS,
    title: 'How to invest (Bonds)',
    subtitle: '',
    videos: 'Erwin W. Heri',
    layoutAndProduction: 'Hanspeter Frey',
    scope: { pages: 27, videos: 27 },
    price: [29, 35],
    introductions: ['The second part of our digital book series on the basics of investing deals with bonds'],
    image: howToInvestBondsImg,
    overviewImg: howToInvestBondsImg,
  },
  bookIds: [51, 52],
  getDefaultOption: ({ isPremium, isBasic }) => (isBasic && 1) || (!isPremium && 2) || 0,
  getDefaultStrictMode: ({ isPremium, isBasic }) => Boolean(isBasic || isPremium),
  orderOptions: [FLIP_BOOK, GIFT_BOOK],
  purchases: getFlipBookPurchases([29, 35], [52, 51]),
};

export default howToInvestBonds;
